<template>
    <div>
        <form @submit="onSubmit">
            <span class="formstyle1">
              Enter
              <sup>*</sup>
            </span>
            <div class="form-group formpadding">
              <input
                type="text"
                class="form-control"
                required
                placeholder="Name"
                v-model="name"
              />
            </div>
            <div class="form-group formpadding">
                <input
                  type="text"
                  class="form-control"
                  required
                  placeholder=" Common Name"
                  v-model="common_name"
                />
              </div>
              <div class="form-group formpadding">
                <input
                  type="text"
                  class="form-control"
                  required
                  placeholder="sci Name"
                  v-model="sci_name"
                />
              </div>
              <b-button variant="primary" class="btn-fw" type="submit">Submit</b-button>
        </form>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
      name: "addaturtle",
      props: {
        caption: {
          type: String,
          default: "Add a Turtle"
        },
      },
      data: () => {
        return {
          loading: false,
          sci_name: "",
          name: "",
          common_name: "",
        }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();
        var add = {};
        add["name"] = this.name;
        add["common_name"] = this.common_name;
        add["sci_name"] = this.sci_name;
      

        axios({
          method: 'post',
          url: '/turtle/add',
          data: add,
          headers: {
            // 'Access-Control-Allow-Origin': '*',
            // 'Content-Type': 'application/json',
            // 'Accept': 'application/json, text/plain, */*',
            // 'Access-Control-Allow-Headers': 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin',
            // 'scheme': 'http',
            // 'accept-encoding': 'gzip, deflate',
            // 'if-none-match': 'W/"d44d-YLnqnA13ScQlGprMDhHw2PBkEE0"',
            // 'origin': 'http://localhost:8080',
            'x-auth-token': localStorage.getItem('token'),
          },
          //headers['x-auth-token']=localStorage.getItem('token')
        })
          .then(response => {
            this.msg = response.data.msg;
            this.id = response.data._id;
            this.loading = "false";
            if (response.data.status === true) {
                this.$router.push({ path: "/listturtles" });
            }
            if (response.data.status === false) {
              this.$router.push({ path: "/addaturtle" });
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
    

    }
  };
</script>